module.exports = __webpack_public_path__ + "img/circle_num_2_green.f31ee890.svg";